import { TwStyle } from 'twin.macro';

import { IntervieweeInfoType } from '@/utils/convertIntervieweeInfo';

export interface IntervieweeCardContainerProps extends IntervieweeInfoType {
  isSessionDataLoading: boolean;
  refetchSession?: () => void;
  refetchQuestionSnapshots?: () => void;
  viewer?: boolean; // this is being used in the <intervieweeView />
}

export enum LINK_TYPE {
  URL_COPY = 'url_copy',
  EXPIRY_LINK_COPY = 'expiry_link_copy',
  ACTIVATE_MODAL = 'activate_modal',
}

export interface ActionBoxDataType {
  label: string;
  description?: string;
  urls: {
    linkType: LINK_TYPE;
    value: string | (() => void);
  }[];
  handleRefreshUrl?: () => void;
  isLoading?: boolean;
  shouldDisplay: boolean;
}

export interface InfoBoxDataType {
  label: string;
  value: string | null | undefined;
  shouldDisplay: boolean;
}

export interface ProfileCardDataType {
  highlightCount?: IntervieweeInfoType['highlightCount'];
  infoBoxData: InfoBoxDataType[];
  intervieweeEmail: IntervieweeInfoType['intervieweeEmail'];
  intervieweeName: IntervieweeInfoType['intervieweeName'];
  refId?: IntervieweeInfoType['refId'];
  refUrl?: IntervieweeInfoType['refUrl'];
  statusStyle: TwStyle;
  statusText: string;
  rerecordingStatus?: IntervieweeInfoType['rerecordingStatus'];
}
